<template>
  <div class="feedback">
    <template v-if="!feedbackRecieved">
      <h5>Is this widget valuable for you?</h5>
      <div>
        <button @click="onYes()">Yes</button>
        <button @click="onNo()">No</button>
      </div>
    </template>
    <h5 v-else>Thanks! We will use your feedback to improve our service.</h5>
  </div>
</template>

<script>
export default {
  props: {
    widgetName: String,
  },
  data() {
    return {
      feedbackRecieved: false,
    };
  },
  methods: {
    onYes() {
      window.dataLayer.push({
        event: 'WidgetFeedback',
        widgetName: this.widgetName || 'unknown widget',
        feedback: true,
      });
      this.feedbackRecieved = true;
    },
    onNo() {
      window.dataLayer.push({
        event: 'WidgetFeedback',
        widgetName: this.widgetName || 'unknown widget',
        feedback: false,
      });
      this.feedbackRecieved = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback {
  text-align: center;

  button {
    color: $apnic-blue;
    background-color: white;
    padding: 4px;
    margin: 0 8px;
    width: 75px;
    border: 1px solid $apnic-blue;
    transition: 0.3s all;

    &:hover {
      color: white;
      background-color: $apnic-blue;
    }
  }
}
</style>
